module.exports = __webpack_public_path__ + "img/en.2014e349.png";